import { Column } from 'seagull';
import { AttachmentFile } from "./AttachmentFile";
import { AttachmentsTestIds } from "./Attachments.utils";
import { AttachmentTitle } from "./AttachmentTitle";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Attachments = _ref => {
  let {
    files,
    onRemove
  } = _ref;
  if (files.length === 0) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": AttachmentsTestIds.Root(),
    children: [/*#__PURE__*/_jsx(AttachmentTitle, {}), /*#__PURE__*/_jsx(Column, {
      children: files.map((file, index) => /*#__PURE__*/_jsx(AttachmentFile, {
        file: file,
        index: index,
        onRemove: onRemove
      }, file.id))
    })]
  });
};